import { Icon, IconProps } from './Icon';

export type BellIconProps = IconProps & {
  showUnreadDot?: boolean;
};

export const BellIcon = ({ showUnreadDot = false, ...props }: BellIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 32 32"
  >
    <path
      d="M12.9443 24.4586V24.9453C12.9443 26.6319 14.3123 27.9999 16.0003 27.9999V27.9999C17.6883 27.9999 19.0563 26.6319 19.0563 24.9439V24.4573"
      stroke="#222B3A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.4437 7.668V6.444C18.4437 5.09467 17.3503 4 15.9997 4V4C14.649 4 13.5557 5.09467 13.5557 6.444V7.668"
      stroke="#222B3A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.75034 13.5841V13.5841C8.75034 10.2467 11.4557 7.54272 14.7917 7.54272H17.209C20.5463 7.54272 23.2503 10.2481 23.2503 13.5841V13.5841V17.3134C23.2503 18.0201 23.5317 18.6987 24.0317 19.1987L24.8863 20.0534C25.3863 20.5534 25.6677 21.2321 25.6677 21.9387V21.9387C25.6677 23.3307 24.5397 24.4587 23.1477 24.4587H8.85301C7.46101 24.4587 6.33301 23.3307 6.33301 21.9387V21.9387C6.33301 21.2321 6.61434 20.5534 7.11434 20.0534L7.96901 19.1987C8.46901 18.6987 8.75034 18.0201 8.75034 17.3134V13.5841Z"
      stroke="#222B3A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {showUnreadDot ? (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.5 6C25.9858 6 28 8.0142 28 10.5C28 12.9858 25.9858 15 23.5 15C21.0142 15 19 12.9858 19 10.5C19 8.0142 21.016 6 23.5 6Z"
        fill="#C8102E"
      />
    ) : null}
  </Icon>
);
